import { z } from 'zod';

export const apiErrorCodes = [
  'UNAUTHENTICATED',
  'TOKEN_INVALID',
  'EMAIL_NOT_AUTHORIZED',
  'ACCOUNT_DISABLED',
  'FORBIDDEN',
  'NOT_FOUND',
  'VALIDATION_ERROR',
  'CONFLICT',
  'RATE_LIMITED',
  'INTEGRATION_NOT_CONFIGURED',
  'INTERNAL_ERROR',
] as const;

export type ApiErrorCode = (typeof apiErrorCodes)[number];

export const ApiFieldErrorSchema = z.object({
  path: z.string(),
  code: z.string(),
  message: z.string(),
});

export type ApiFieldError = z.infer<typeof ApiFieldErrorSchema>;

export const ApiErrorSchema = z.object({
  code: z.enum(apiErrorCodes),
  message: z.string(),
  requestId: z.string(),
  fields: z.array(ApiFieldErrorSchema).optional(),
  details: z.record(z.string(), z.unknown()).optional(),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;

export const ApiFailureSchema = z.object({
  error: ApiErrorSchema,
});

export const VALIDATION_ERROR_MESSAGE = 'Request validation failed';

export class ApiClientError extends Error {
  constructor(
    public readonly status: number,
    public readonly error: ApiError,
  ) {
    super(error.message);
    this.name = 'ApiClientError';
  }

  get code(): ApiErrorCode {
    return this.error.code;
  }
}
